import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import {
  BehaviorSubject,
  Subscription,
  filter,
  merge,
  startWith,
  switchMap,
} from 'rxjs';
import { AtomParams, AtomService } from 'src/app/core/atom.service';
import { FilterData } from 'src/app/filter/filter';
import { FilterEditorComponent } from 'src/app/filter/filter-editor/filter-editor.component';
import { FiltersComponent } from 'src/app/filter/filters/filters.component';
import { Translatable } from 'src/app/translation/translatable';
import { TranslatePipe } from 'src/app/translation/translate.pipe';
import { ConfigData } from '../search-config';

@Component({
  selector: 'atm-search-ressource',
  templateUrl: './search-ressource.component.html',
  styleUrls: ['./search-ressource.component.scss'],
})
export class SearchRessourceComponent implements OnInit, OnChanges {
  @Input() config: ConfigData = this.data?.conf;
  @Input() filtersSetted: AtomParams['filter'] | null = null;
  @Input() closeAfterSelect: boolean = this.data?.closeAfterSelect || false;
  @Output() selected = new EventEmitter<any>();

  isLoading = false;

  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;

  @ViewChild(FiltersComponent, { static: true })
  filtersComponent!: FiltersComponent;

  private filters: FilterData[] = [];
  filtersChanged = new BehaviorSubject<any>({});

  ressources!: any[];
  selectedRessource: any = null;
  goToFirstPageSub = Subscription.EMPTY;

  constructor(
    private atom: AtomService,
    public dialog: MatDialog,
    private translate: TranslatePipe,
    @Inject(MAT_DIALOG_DATA)
    public data: { conf: ConfigData; closeAfterSelect: boolean },
    public dialogRef: MatDialogRef<SearchRessourceComponent>
  ) {}

  ngOnInit(): void {
    this.filtersSetted = this.filtersSetted || this.config.filtersSetted;
    console.log(this.filtersSetted);
    this.goToFirstPageSub = merge(
      this.filtersComponent.filtersChanged
    ).subscribe(() => this.paginator!.firstPage());
    merge(this.paginator.page, this.filtersComponent.filtersChanged)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          return this.atom.all(this.config.resource, {
            include: this.config.include,
            filter: this.filtersComponent.value || {},
            pageIndex: this.paginator!.pageIndex,
            pageSize: this.paginator!.pageSize,
          });
        })
      )
      .subscribe(({ data, meta }) => {
        this.paginator!.length = meta.pagination.total;
        this.ressources = data;
        this.isLoading = false;
      });
  }

  ngOnChanges(): void {
    this.filtersComponent.value = this.config.filtersSetted || {};
    this.filtersComponent.filtersChanged.next(this.filtersComponent.value);
    this.paginator!.pageIndex = 0;
    this.paginator!.pageSize = 25;
  }

  filter(): void {
    this.openFilterEditor()
      .afterClosed()
      .pipe(filter((res) => !!res))
      .subscribe((res) => {
        this.paginator!.pageIndex = 1;
        this.filters = this.filters.concat(res!);
      });
  }

  getData(path: string, obj: any, translate: boolean): string | Translatable {
    let res = path.split('.').reduce((o, k) => o && o[k], obj);
    return translate ? this.translate.transform(res) : res;
  }

  select(resource: any) {
    this.selectedRessource = resource;
    this.selected.emit(resource);
    if (this.closeAfterSelect) {
      this.dialogRef.close(resource);
    }
  }

  private openFilterEditor(
    data?: FilterData
  ): MatDialogRef<FilterEditorComponent, FilterData> {
    return this.dialog.open(FilterEditorComponent, {
      data: { data, filters: this.config.filters },
      width: '620px',
    });
  }
}
